module.exports = __webpack_public_path__ + "img/photo-2.106e5e05.jpg";